import { CompanyContainer, CompanyContentContainer } from "components/company/v3/CompanyContainers";
import AmericanAboutContent from "components/company/v3/american/contents/about/AmericanAboutContent";
import type { ReactNode } from "react";

interface AmericanAboutBoxProps {
  tickerSymbol: string;
  children?: ReactNode;
}

export default function AmericanAboutBox({ tickerSymbol, children }: AmericanAboutBoxProps) {
  return (
    <CompanyContainer className="xl:h-full">
      <div className="flex w-full flex-col space-y-6">
        <CompanyContentContainer>
          <div className="w-full space-y-4 border-none p-6">
            <AmericanAboutContent tickerSymbol={tickerSymbol} />
          </div>
        </CompanyContentContainer>
        {children}
      </div>
    </CompanyContainer>
  );
}
